import React from 'react';
import { Link } from 'react-router-dom';
import terySad from '../../../../public/tery/tery_sad.png';

/**
 * Mirrors Figma node `9261:733487`. Bold reminder + sad squirrel mascot.
 * Whole card is a Link to `/learn/prizes`.
 */
export default function PrizeReminderCard() {
  return (
    <Link
      to="/learn/prizes"
      className="group flex-1 lg:max-w-[392px] w-full flex flex-col items-center justify-end self-stretch active:scale-[0.99] transition-transform duration-fast ease-out-strong"
      aria-label="Go to the prize shop"
    >
      <p className="text-base font-bold text-text-primary text-center leading-snug px-4">
        Do not forget to check the gamification section and claim your prize before the deadline!
      </p>
      <img
        src={terySad}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="select-none pointer-events-none w-full max-w-[280px] lg:max-w-none object-contain mt-4 transition-transform duration-300 ease-out-strong @media(hover:hover){group-hover:translate-y-[-2px]}"
      />
    </Link>
  );
}
